import { Injectable, ElementRef, Renderer } from '@angular/core';

@Injectable()
export class NotificationService {

    isDelayed: boolean = true;
    delay = 3000;

    constructor(private el: ElementRef, private renderer: Renderer) { 
    }

    notify(text) {
        let e = this.el.nativeElement.querySelector('#snackbar');
        this.renderer.setElementClass(e,'show',true);
        this.renderer.setText(e,text);
        if(this.isDelayed){
            setTimeout(()=>{
                this.renderer.setElementClass(e,'show',false);
            }, this.delay);
        }
    }

    setNoDelay(){
        this.isDelayed = false;
    }

    setDelay(val?){
        this.isDelayed = true;
        if(val)
            this.delay = val;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/notification.service.ts